<template>
  <section class="custom-storage">
    <storage />
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import Storage from '@/Components/AzureStorage/storage-listing'
export default {
  name: 'organization-storage',
  components: {
    Storage,
  },
  computed: {
    ...mapGetters('organizations', ['organization']),
  },
}
</script>
<style lang="scss" scoped>
.custom-storage {
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 550px;
  width: 100%;
}
</style>
